import Layout from '../views/layout/index.vue'
import AdminLayout from '../views/layout/admin.vue'

const _import = file => resolve => require(['@/views/' + file + '.vue'], resolve)

/**
  * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
  * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
  *                                if not set alwaysShow, only more than one route under the children
  *                                it will becomes nested mode, otherwise not show the root menu
  * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
  * name:'router-name'             the name is used by <keep-alive> (must set!!!)
  * meta : {
      roles: ['admin','editor']     will control the page roles (you can set multiple roles)
      title: 'title'               the name show in submenu and breadcrumb (recommend set)
      icon: 'svg-name'             the icon show in the sidebar,
      noCache: true                if true ,the page will no be cached(default is false)
    }
 */
export const constantRouterMap = [
  { path: '/login', component: _import('login/loginindex'), hidden: true },
  { path: '/tourist', component: _import('login/tourist'), hidden: true },
  { path: '/watermanage', component: _import('login/watermanage'), hidden: true },
  { path: '/authredirect', component: _import('login/authredirect'), hidden: true },
  { path: '/404', component: _import('error/404'), hidden: true },
  { path: '/401', component: _import('error/401'), hidden: true },
  { path: '/nav',
    redirect: '/nav/Homepage',
    component: _import('nav/index'),
    hidden: false,
    children: [{
      path: 'homepage',
      component: _import('homepage/index'),
      name: 'Homepage'
    }, {
      // 数据中心
      path: 'scene',
      component: _import('scene/index'),
      // redirect: 'scene/reservoir',
      name: 'Scene',
      children: [{
        path: 'gatedetail',
        meta: '数据中心',
        component: _import('scene/gatedetail/index'),
        name: 'Scene/Gatedetail'
      }, {
        path: 'projectinspect',
        meta: '数据中心',
        component: _import('scene/projectinspect/index'),
        name: 'Scene/Projectinspect'
      }, {
        path: 'prevention',
        meta: '数据中心',
        component: _import('scene/prevention/index'),
        name: 'Scene/PreventInfo'
      }, {
        path: 'hismountain',
        meta: '数据中心',
        component: _import('scene/hismountain/index'),
        name: 'Scene/HisMountain'
      }, {
        path: 'reservoir',
        meta: '数据中心',
        component: _import('scene/reservoir/index'),
        name: 'Scene/Reservoir'
      }, { // 山塘
        path: 'hillpond',
        meta: '数据中心',
        component: _import('scene/hillpond/index'),
        name: 'Scene/Hillpond'
      }, {
        path: 'sluice',
        meta: '数据中心',
        component: _import('scene/sluice/index'),
        name: 'Scene/Sluice'
      }, {
        path: 'dike',
        meta: '数据中心',
        component: _import('scene/dike/index'),
        name: 'Scene/Dike'
      }, {
        path: 'ponddam',
        meta: '数据中心',
        component: _import('scene/ponddam/index'),
        name: 'Scene/Ponddam'
      }, {
        path: 'rainfall',
        meta: '数据中心',
        component: _import('scene/rainfall/index'),
        name: 'Scene/Rainfall'
      }, {
        path: 'waterfall',
        meta: '数据中心',
        component: _import('scene/waterfall/index'),
        name: 'Scene/Waterfall'
      }, {
        path: 'automatic',
        meta: '数据中心',
        component: _import('scene/automatic/index'),
        name: 'Scene/Automatic'
      }, {
        path: 'planinfo',
        meta: '数据中心',
        component: _import('scene/planinfo/index'),
        name: 'Scene/Planinfo'
      }, {
        path: 'indicatorinfo',
        meta: '数据中心',
        component: _import('scene/indicatorinfo/index'),
        name: 'Scene/Indicatorinfo'
      }, {
        path: 'adcdInfo',
        meta: '数据中心',
        component: _import('scene/adcdInfo/index'), // 行政区划信息
        name: 'Scene/AdcdInfo'
      }, {
        path: 'waterconfig',
        meta: '用户中心',
        component: _import('usercenter/waterconfig/index'), // 水位设置
        name: 'Scene/Waterconfig'
      }, {
        path: 'irrigationworks',
        meta: '数据中心',
        component: _import('scene/irrigationworks/index'), // 水利工程
        name: 'Scene/IrrigationWorks'
      }, {
        path: 'inabilityCurve',
        meta: '库容曲线',
        component: _import('scene/inabilityCurve/index'), // 库容曲线
        name: 'Scene/InabilityCurve'
      }, {
        path: 'reslimitedwater',
        meta: '库容曲线',
        component: _import('scene/reslimitedwater/index'), // 库(湖)站汛限水位
        name: 'Scene/ReslimitedWater'
      }]
    }, {
      // 报表分析
      path: 'reportanalysis',
      component: _import('report/index'),
      name: 'Report',
      children: [{
        path: 'arearainfall',
        meta: '报表分析',
        component: _import('report/arearainfall/index'), // 分区雨量
        name: 'Report/AreaRainfall'
      }, {
        path: 'reservoirdynamic',
        meta: '报表分析',
        component: _import('report/reservoirDynamicStorage/index'), // 水库动态蓄水
        name: 'Report/ReservoirDynamicStorage'
      }, {
        path: 'waterraindaily',
        meta: '报表分析',
        component: _import('report/waterRainDaily/index'), // 水雨情日报
        name: 'Report/WaterRainDaily'
      }, {
        path: 'waterrainbriefing',
        meta: '报表分析',
        component: _import('report/waterRainBriefing/index'), // 水雨情简报
        name: 'Report/WaterRainBriefing'
      }, {
        path: 'arrivalratestatistics',
        meta: '报表分析',
        component: _import('report/arrivalRateStatistics/index'), // 到站率统计
        name: 'Report/ArrivalRateStatistics'
      },
      {
        path: 'waterrainnotice',
        meta: '报表分析',
        component: _import('report/waterRainNotice/index'), // 雨水情告知单
        name: 'Report/WaterRainNotice'
      }, {
        path: 'unusualDataReport',
        meta: '报表分析',
        component: _import('report/unusualDataReport/index'), // 异常数据报表
        name: 'Report/UnusualDataReport'
      }, {
        path: 'waterBreakingNews',
        meta: '报表分析',
        component: _import('report/waterBreakingNews/index'), // 水情快报
        name: 'Report/waterBreakingNews'
      }]
    }, {
      // 监测中心
      path: 'monitoringcenter',
      component: _import('monitoringcenter/index'),
      name: 'Monitor',
      // redirect: 'monitoringcenter/realtimerain',
      children: [{
        path: 'realtimerain',
        meta: '监测中心',
        component: _import('monitoringcenter/realtimerain/index'),
        name: 'Monitor/RealTimeRain'
      }, {
        path: 'districtrain',
        meta: '监测中心',
        component: _import('monitoringcenter/districtrain/index'),
        name: 'Monitor/districtrain'
      }, {
        path: 'rainstatis',
        meta: '监测中心',
        component: _import('monitoringcenter/rainstatis/index'),
        name: 'Monitor/RainStatis'
      }, { // 新增水库水情报表
        path: 'reservoirwaterReport',
        meta: '监测中心',
        component: _import('monitoringcenter/reservoirwaterReport/index'),
        name: 'Monitor/ReservoirWaterReport'
      }, { // 新增河道水情报表
        path: 'riverWaterReport',
        meta: '监测中心',
        component: _import('monitoringcenter/riverWaterReport/index'),
        name: 'Monitor/RiverWaterReport'
      }, {
        path: 'riverwater',
        meta: '监测中心',
        component: _import('monitoringcenter/riverwater/index'),
        name: 'Monitor/RiverWater'
      }, {
        path: 'reservoirwater',
        meta: '监测中心',
        component: _import('monitoringcenter/reservoirwater/index'),
        name: 'Monitor/ReservoirWater'
      }, {
        path: 'waterAndRainStatistics',
        meta: '监测中心',
        component: _import('monitoringcenter/waterAndRainStatistics/index'),
        name: 'Monitor/WaterAndRainStatistics'
      }, {
        path: 'weather',
        meta: '监测中心',
        component: _import('monitoringcenter/weather/index'),
        name: 'Monitor/Weather'
      }, {
        path: 'typhoon',
        meta: '监测中心',
        component: _import('monitoringcenter/typhoon/index'),
        name: 'Monitor/Typhoon'
      }, {
        path: 'satellite',
        meta: '监测中心',
        component: _import('monitoringcenter/satellite/index'),
        name: 'Monitor/Satellite'
      }, {
        path: 'radar',
        meta: '监测中心',
        component: _import('monitoringcenter/radar/index'),
        name: 'Monitor/Radar'
      }, {
        path: 'shortforecast',
        meta: '监测中心',
        component: _import('monitoringcenter/shortforecast/index'),
        name: 'Monitor/ShortForecast'
      }, {
        path: 'videosur',
        meta: '监测中心',
        component: _import('monitoringcenter/videosur/index'),
        name: 'Monitor/VideoSur'
      }, {
        path: 'rainwaterReport',
        meta: '监测中心',
        component: _import('monitoringcenter/rainwaterReport/index'),
        name: 'Monitor/rainwaterReport'
      }, {
        path: 'meanrainfall',
        meta: '雨水情',
        component: _import('monitoringcenter/meanrainfall/index'),
        name: 'Monitor/Meanrainfall'
      }]
    }, {
      // 预警中心
      path: 'warningcenter',
      component: _import('warningcenter/index'),
      // redirect: 'warningcenter/realtimemsgsend',
      name: 'WarningCenter',
      children: [{
        path: 'realtimemsgsend',
        meta: '预警中心',
        component: _import('warningcenter/realtimemsgsend/index'),
        name: 'WarningCenter/RealTimeMsgSend'
      }, {
        path: 'manageinfo',
        meta: '预警中心',
        component: _import('warningcenter/manageinfo/index'),
        name: 'WarningCenter/Manageinfo'
      }, {
        path: 'warnstaffing',
        meta: '预警中心',
        component: _import('warningcenter/warnstaffing/index'),
        name: 'WarningCenter/WarnStaffing'
      }, {
        path: 'inquireHasBeenSentSMS',
        meta: '预警中心',
        component: _import('warningcenter/inquireHasBeenSentSMS/index'),
        name: 'WarningCenter/InquireHasBeenSentSMS'
      }, {
        path: 'warnInformationView',
        meta: '预警中心',
        component: _import('warningcenter/warnInformationView/index'),
        name: 'WarningCenter/warnInformationView'
      }, {
        path: 'smsTemplateManagement',
        meta: '预警中心',
        component: _import('warningcenter/smsTemplateManagement/index'),
        name: 'WarningCenter/smsTemplateManagement'
      }, {
        path: 'groupRelations',
        meta: '预警中心',
        component: _import('warningcenter/groupRelations/index'),
        name: 'WarningCenter/groupRelations'
      }, {
        path: 'warninfo',
        meta: '预警中心',
        component: _import('warningcenter/warninfo/index'),
        name: 'WarningCenter/warninfo'
      }, {
        path: 'forecastSms',
        meta: '预警中心',
        component: _import('warningcenter/forecastSms/index'),
        name: 'WarningCenter/forecastSms'
      }]
    }, {
      // 用户中心
      path: 'usercenter',
      component: _import('usercenter/index'),
      // redirect: 'usercenter/usemanage',
      name: 'UserCenter',
      children: [{
        path: 'usemanage',
        meta: '用户中心',
        component: _import('usercenter/usemanage/index'),
        name: 'UserCenter/UseManage'
      }, {
        path: 'rolemanage',
        meta: '用户中心',
        component: _import('usercenter/rolemanage/index'),
        name: 'UserCenter/RoleManage'
      }, {
        path: 'siteconfig',
        meta: '用户中心',
        component: _import('usercenter/siteconfig/index'),
        name: 'UserCenter/SiteConfig'
      }, {
        path: 'permission',
        meta: '用户中心',
        component: _import('usercenter/permission/index'),
        name: 'UserCenter/PermissionManage'
      }, {
        path: 'waterconfig',
        meta: '用户中心',
        component: _import('usercenter/waterconfig/index'), // 水位设置
        name: 'UserCenter/Waterconfig'
      }, {
        path: 'logmanage',
        meta: '用户中心',
        component: _import('usercenter/logmanage/index'), // 日志管理
        name: 'UserCenter/Logmanage'
      }, {
        path: 'unusualDataReport',
        meta: '用户中心',
        component: _import('usercenter/unusualDataReport/index'), // 异常数据报表
        name: 'UserCenter/UnusualDataReport'
      }]
    }, {
      // 场景应用
      path: 'applicationScenarios',
      component: _import('applicationScenarios/index'),
      name: 'ApplicationScenarios'
    }]
  },
  // { path: '/yjxbasin', component: _import('defenseposture/index'), hidden: false, name: 'yjxbasin' },
  { path: '/waterrainbigscreen/yjxbasin', component: _import('waterrainbigscreen/index'), hidden: false, name: 'yjxbasin' },
  { path: '/meiyu', component: _import('meiyu/index'), hidden: false, name: 'meiyu' },
  { path: '/openScreen', component: _import('meiyu2/index'), hidden: false, name: 'openScreen' },
  { path: '/typhoon', component: _import('typhoon/index'), hidden: false, name: 'typhoon' },
  { path: '/drought', component: _import('drought/index'), hidden: false },
  { path: '/nonfloodseason', component: _import('nonfloodseason/index'), hidden: false },
  { path: '/riskchart', component: _import('riskchart/index'), hidden: false, name: 'riskchart' },
  {
    hidden: true,
    path: '',
    component: Layout,
    redirect: 'home',
    children: [{
      path: '/home',
      component: _import('home/index'),
      name: 'home',
      meta: { title: '首页', icon: 'fa-home', noCache: true }
    }]
  },
  {
    path: '/dashboard',
    component: AdminLayout,
    redirct: '/dashboard/index',
    children: [{
      path: 'index',
      component: _import('dashboard/index'),
      name: 'dashboard',
      meta: { title: '首页', icon: 'fa-home', noCache: true }
    }]
  }
]

export const asyncRouterMap = [
  {
    path: '/district',
    component: AdminLayout,
    meta: { title: '行政区划' },
    redirct: '/district/index',
    children: [{
      path: 'index',
      component: _import('district/index'),
      name: 'district',
      meta: {
        title: '行政区划',
        icon: 'fa-chart-area',
        roles: ['admin']
      }
    }]
  },
  {
    path: '/org',
    component: AdminLayout,
    meta: { title: '组织管理' },
    redirct: '/org/index',
    children: [{
      path: 'index',
      component: _import('org/index'),
      name: 'org',
      meta: {
        title: '组织管理',
        icon: 'fa-sitemap',
        roles: ['admin']
      }
    }]
  },
  {
    path: '/permission',
    component: AdminLayout,
    meta: { title: '权限管理' },
    redirect: '/permission/admin',
    children: [{
      path: 'admin',
      component: _import('permission/index'),
      name: 'permissionAdmin',
      meta: {
        title: '权限管理',
        icon: 'fa-cogs',
        roles: ['admin']
      }
    }]
  },
  {
    hidden: true,
    path: '/permission',
    component: AdminLayout,
    redirct: '/permission/index',
    children: [{
      path: 'index/:appKey',
      component: _import('permission/index'),
      name: 'permission',
      meta: {
        icon: 'fa-cogs',
        title: '权限管理'
      }
    },
    {
      path: 'edit/:id',
      component: _import('permission/edit'),
      name: 'permission_edit',
      meta: {
        icon: 'fa-cogs',
        title: '权限维护'
      }
    }]
  },
  {
    path: '/role',
    component: AdminLayout,
    meta: { title: '角色管理' },
    redirect: '/role/index',
    children: [{
      path: 'index/:appKey',
      component: _import('role/index'),
      name: 'role',
      meta: {
        title: '角色管理',
        icon: 'fa-user-tag'
      }
    }]
  },
  {
    path: '/user',
    component: AdminLayout,
    meta: { title: '用户管理' },
    redirct: '/user/index',
    children: [{
      path: 'index',
      component: _import('user/index'),
      name: 'user',
      meta: {
        title: '用户管理',
        icon: 'fa-user',
        roles: ['admin']
      }
    }]
  },
  {
    path: '/siteconfig',
    component: AdminLayout,
    meta: { title: '站点配置' },
    redirct: '/siteconfig/index',
    children: [{
      path: 'index',
      component: _import('siteconfig/index'),
      name: 'siteconfig',
      meta: {
        title: '站点配置',
        icon: 'fa-user'
      }
    }]
  },
  {
    hidden: true,
    path: '/info',
    component: Layout,
    meta: {
      title: '组织管理',
      icon: 'fa-sitemap'
    },
    redirct: '/info/index',
    children: [{
      path: 'index',
      component: _import('info/index'),
      name: 'info',
      meta: {
        title: '工程概况',
        icon: 'fa-user'
      }
    }]
  },

  { path: '*', redirect: '/404', hidden: true }
]
